export default class ToastService {
    toast;
    life = 3000;
    constructor(toast) {
        this.toast = toast;
    }
    storeSuccess() {
        this.toast.add({
            severity: 'success',
            summary: 'Salvataggio effettuato',
            detail: 'Le moifiche sono state memorizzate.',
            life: this.life,
        });
    }
    deleteSuccess() {
        this.toast.add({
            severity: 'success',
            summary: 'Eliminazione effettuata',
            detail: 'Il record è stato eliminato.',
            life: this.life,
        });
    }
    error(message, optionsOverrides = {}) {
        const options = Object.assign({
            severity: 'error',
            summary: 'Errore',
            detail: message,
            life: this.life,
        }, optionsOverrides);
        this.toast.add(options);
    }
}
